import { IRecordPageEdit, RecordPageEdit } from "./recordPageEdit";
import { IRecordPageList, RecordPageList } from "./recordPageList";

export interface IRecordPage {
    list: IRecordPageList;
    edit: IRecordPageEdit;
}

export class RecordPage implements IRecordPage {
    list: RecordPageList;
    edit: RecordPageEdit;

    constructor();
    constructor(obj: IRecordPage);
    constructor(obj?: any) {
        this.list = new RecordPageList(obj && obj.list || null);
        this.edit = new RecordPageEdit(obj && obj.edit || null);
    }
}